import { motion } from "framer-motion";
import { Star, Quote, ExternalLink } from "lucide-react";
import { TESTIMONIALS, GOOGLE_REVIEWS_URL } from "@/content/testimonials";

const EASE = [0.16, 1, 0.3, 1];

function Stars({ n }) {
  return (
    <div className="flex gap-1">
      {Array.from({ length: 5 }, (_, i) => (
        <Star key={i} className={`w-3.5 h-3.5 ${i < n ? "text-nc-orange fill-nc-orange" : "text-zinc-700"}`} />
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <div data-testid="testimonials-section">
      {TESTIMONIALS.length === 0 ? (
        <a
          href={GOOGLE_REVIEWS_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="testimonials-google-cta"
          className="group border border-white/10 bg-black/40 p-8 flex flex-col md:flex-row md:items-center gap-6 hover:border-nc-orange/50 transition-colors duration-300"
        >
          <span className="w-14 h-14 border border-nc-orange/40 bg-nc-orange/10 flex items-center justify-center shrink-0">
            <Star className="w-6 h-6 text-nc-orange fill-nc-orange" />
          </span>
          <div className="flex-1">
            <h3 className="font-sans font-bold uppercase text-xl text-zinc-50 group-hover:text-nc-orange transition-colors duration-300">
              Rated by our clients on Google
            </h3>
            <p className="font-mono text-xs text-zinc-500 mt-2 leading-relaxed">
              Read what studios say about working with Specpixel — or leave your own review after we ship together.
            </p>
          </div>
          <span className="font-mono text-[10px] tracking-[0.25em] text-nc-orange uppercase flex items-center gap-2 shrink-0">
            See Google reviews <ExternalLink className="w-3.5 h-3.5" />
          </span>
        </a>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={`${t.name}-${i}`}
              data-testid={`testimonial-${i + 1}`}
              className="border border-white/10 bg-black/40 p-6 flex flex-col gap-4 hover:border-white/30 transition-colors duration-300"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.08, ease: EASE }}
            >
              <Quote className="w-5 h-5 text-nc-blue" />
              <blockquote className="font-mono text-sm text-zinc-300 leading-relaxed flex-1">"{t.text}"</blockquote>
              <figcaption className="flex items-center justify-between border-t border-white/10 pt-4">
                <span className="font-sans font-semibold uppercase text-xs text-zinc-100">{t.name}</span>
                <Stars n={t.stars} />
              </figcaption>
            </motion.figure>
          ))}
          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="testimonials-google-link"
            className="font-mono text-[10px] tracking-[0.25em] text-nc-blue uppercase flex items-center gap-2 hover:text-nc-orange transition-colors md:col-span-2 justify-end"
          >
            All reviews on Google <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>
      )}
    </div>
  );
}
